import cmsBackup, { SECTION_NAME_MAP } from '@src/enums/content';
import { makeAutoObservable } from 'mobx';

export interface LocalDataItem {
  id: string;
  categoryId: string;
  type: 'category' | 'section';
  data: any;
  operate: string;
  modifyTime: number;
  previewed: string[];
}

export default class CmsData {
  cmsData: any = {
    globalConfig: {},
    sectionTypes: [],
  };

  localData: LocalDataItem[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setCmsData = (cmsData: CmsData['cmsData'] | null) => {
    this.cmsData = cmsData || cmsBackup;
  };

  getSectionById = (id: string): any[] => {
    const section = this.cmsData.sectionTypes.find((_section) => _section.id === id);
    return section?.sections || [];
  };

  getSectionByName = (sectionName: string) => {
    const section = this.cmsData.sectionTypes.find((_section) => _section.sectionName === sectionName);
    return section?.sections || [];
  };

  getSectionWithExtraById = (id: string) => {
    const section = this.cmsData.sectionTypes.find((_section) => _section.id === id);

    return (
      section?.sections?.map((item) => ({
        ...item,
        extra: this.getExtraRecursion(item),
      })) || []
    );
  };

  getSectionWithExtraByName = (sectionName: string) => {
    const section = this.cmsData.sectionTypes.find((_section) => _section.sectionName === sectionName);
    if (section?.extra) {
      section.extra = this.getExtra(section);
    }
    return section?.sections || [];
  };

  // 获取首页展示的问题
  getHomeQuestion = () => {
    const socialList = this.getSectionByName(SECTION_NAME_MAP.socialQuestionList);
    const campusList = this.getSectionByName(SECTION_NAME_MAP.campusQuestionList);

    const res: any[] = [];
    socialList.forEach((social) => {
      social.extra?.forEach((item) => {
        const questions = this.getSectionById(item);
        questions.forEach((question) => {
          if (question.isNotice) {
            res.push({ ...question, type: 'social' });
          }
        });
      });
    });
    campusList.forEach((campus) => {
      campus.extra?.forEach((item) => {
        const questions = this.getSectionById(item);
        questions.forEach((question) => {
          if (question.isNotice) {
            res.push({ ...question, type: 'campus' });
          }
        });
      });
    });

    return res;
  };

  // 获取首页展示的公告
  getHomeNotice = () => {
    const noticeList: any[] = this.getSectionByName(SECTION_NAME_MAP.announcementList);
    return noticeList.filter((notice) => notice.isNotice);
  };

  // 获取extra数据
  getExtra = (parent: any) => {
    if (!parent?.extra) return [];

    const res: any[] = [];
    parent.extra.forEach((item) => {
      res.push(...this.getSectionById(item));
    });

    return res;
  };

  getExtraRecursion = (parent: any) => {
    if (!parent?.extra) return [];

    const res: any[] = [];
    parent.extra.forEach((item) => {
      res.push(...this.getSectionWithExtraById(item));
    });

    return res;
  };
}
